export default [
  {
    title: 'medtastic.workshops',
    requiredPermissions: [
      'POST api/medtastic/workshops/{id}',
      'DELETE api/medtastic/workshops/{id}'
    ],
    target: 'medtastic.workshop_list'
  },
  {
    title: 'medtastic.sponsors',
    requiredPermissions: [
      'POST api/medtastic/sponsors/{id}',
      'DELETE api/medtastic/sponsors/{id}'
    ],
    target: 'medtastic.sponsor_list'
  },
  {
    title: 'core.system',
    children: [
      {
        title: 'core.users',
        requiredPermissions: [
          'POST api/system/users/{id}',
          'DELETE api/system/users/{id}'
        ],
        target: 'system.user_list'
      },
      {
        title: 'core.roles',
        requiredPermissions: [
          'POST api/system/roles/{id}',
          'DELETE api/system/roles/{id}'
        ],
        target: 'system.role_list'
      },
      {
        title: 'core.permissions',
        requiredPermissions: [
          'POST api/system/permissions/{id}',
          'DELETE api/system/permissions/{id}'
        ],
        target: 'system.permission_list'
      },
      {
        title: 'core.translations',
        requiredPermissions: [
          'POST api/system/translations/client-translations',
          'POST api/system/translations/server-translations'
        ],
        target: 'system.translation_list'
      }
    ]
  },
  {
    title: 'medtastic.configuration',
    target: 'medtastic.configuration.notification_email_list',
    requiredPermissions: [
      'POST api/medtastic/notification_emails/{id}',
      'DELETE api/medtastic/notification_emails/{id}'
    ]
  }
]
